import React, { useState, useEffect } from "react";
// Components
import Navbar from "../../components/Navbar";
import iconUser from "../../assets/user/account-circle.svg";
import WhitelistComponent from "../../components/WhitelistComponent";
import * as S from "./styles";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

import { useHistory, useLocation } from "react-router-dom";

export default function UserList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Permissão de Acesso</S.Title>
              <S.Description>
                Tela para permitir quem acessa o sistema.
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        <WhitelistComponent
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
        <GoTopoButtonWrapper>
          <ButtonV2
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            height="32px"
            leftIcon={IoChevronUp}
          >
            Topo
          </ButtonV2>
        </GoTopoButtonWrapper>
      </S.Wrapper>
    </>
  );
}
